import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Collapse } from 'reactstrap';

import 'assets/scss/soonoGetStarted.css';
import SignUpWrapper from 'containers/SignUpWrapper';
import { TRIAL_SIGNUP_ROUTES } from 'constants/Routes';
import { getUserData, getContactDetails } from 'constants/localStorageManager';

class TrialPlan extends Component {
  constructor() {
    super();
    this.state = {
      trialToggle: false,
    };
  }

  handleSubmit = e => {
    const { history } = this.props;
    history.push(TRIAL_SIGNUP_ROUTES.BUSINESS_DETAILS);
  };

  onTrialToggle = () => {
    this.setState(({ trialToggle }) => ({ trialToggle: !trialToggle }));
  };

  render() {
    const { togglePlan, onPlanSelected, location } = this.props;
    const { trialToggle } = this.state;
    const { first_name: firstName } =
      getContactDetails() || getUserData() || {};

    return (
      <SignUpWrapper
        step={TRIAL_SIGNUP_ROUTES.SELECT_PLANS}
        currentStep={location.pathname}
      >
        <div className="col-md-10 offset-md-1">
          <h3 className="mt-5 mb-2 text-dark" style={{ fontWeight: 600 }}>
            Hi {firstName}, Welcome to Soono
          </h3>
          <p className="text-dark">
            Pick which plan to get started. You can downgrade at anytime
          </p>
          <div className="row mt-5 mb-5">
            <div className="col-md-6 offset-md-3">
              <div className="card package-card bg-gradient-trial border-0 p-lg-2 p-0">
                <div className="card-body pt-5 pb-4">
                  <h2 className="card-title text-bold text-white">Free Plan</h2>
                  <h6 className="card-text mb-4 text-white">
                    Try Soono survey free for 7 days.
                  </h6>
                  <div className="card pt-5 pl-3 pr-3 pb-4 border-0 shadow-3">
                    <div className="row mb-3">
                      <div className="col text-center mb-1">
                        <h1 className="text-bold">Free</h1>
                      </div>
                    </div>
                    <ul className="package-features text-left p-lg-2 p-0">
                      <li>
                        <FontAwesomeIcon
                          icon="check-circle"
                          className="text-success steps-icon"
                        />{' '}
                        Survey's
                        <span className="float-right text-bold">1</span>
                      </li>
                      <li>
                        <FontAwesomeIcon
                          icon="check-circle"
                          className="text-success steps-icon"
                        />{' '}
                        Survey participants
                        <span className="float-right text-bold">100</span>
                      </li>
                      <li>
                        <FontAwesomeIcon
                          icon="check-circle"
                          className="text-success steps-icon"
                        />{' '}
                        User accounts
                        <span className="float-right text-bold">1</span>
                      </li>
                      <Collapse
                        isOpen={trialToggle}
                        className="plan-information"
                      >
                        <li>
                          <FontAwesomeIcon
                            icon="check-circle"
                            className="text-success steps-icon"
                          />{' '}
                          1-on-1 consulation fee
                          <span className="float-right text-bold">N/A</span>
                        </li>
                        <li className="text-secondary">
                          <FontAwesomeIcon
                            icon="times-circle"
                            className="text-danger steps-icon"
                          />{' '}
                          Onboarding
                        </li>
                        <li className="text-secondary">
                          <FontAwesomeIcon
                            icon="times-circle"
                            className="text-danger steps-icon"
                          />{' '}
                          Customer support
                        </li>
                        <li className="text-secondary">
                          <FontAwesomeIcon
                            icon="times-circle"
                            className="text-danger steps-icon"
                          />{' '}
                          Growth Add-Ons
                        </li>
                        <li className="text-secondary">
                          <FontAwesomeIcon
                            icon="times-circle"
                            className="text-danger steps-icon"
                          />{' '}
                          SMS short code Add-On
                        </li>
                      </Collapse>
                      <li
                        className="text-center plan-toggler"
                        id="trialToggler"
                        onClick={this.onTrialToggle}
                      >
                        <FontAwesomeIcon
                          icon={trialToggle ? 'angle-up' : 'angle-down'}
                        />
                      </li>
                    </ul>
                    <button
                      className="btn btn-warning col-md-12 py-3 pl-5 pr-5 mt-3 text-white text-bold border-0"
                      type="button"
                      onClick={onPlanSelected}
                    >
                      Select plan
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 mt-5">
              <p>
                Want to get more out of soono? &nbsp;
                <div
                  className="text-bold text-primary cursor-pointer"
                  onClick={togglePlan}
                >
                  Select more plans here.
                </div>
              </p>
            </div>
          </div>
        </div>
      </SignUpWrapper>
    );
  }
}

export default withRouter(TrialPlan);



// WEBPACK FOOTER //
// ./src/components/transactions/TrialPlan.js